import { useApiWithAuth } from "@/modules/api";
import { clearObject } from "@/modules/utils";
import { RntrcFaturamentoFilterPayload } from "./rntrcTypes";

const useRntrcFaturamentoService = () => {
  const { data, loading, get, downloadFile } = useApiWithAuth();

  const listarItens = (
    filter: RntrcFaturamentoFilterPayload,
    page: number
  ): Promise<void> => {
    return get("/rntrc/faturamento", {
      ...clearObject({ ...filter }),
      page: page
    });
  };

  const resumo = (filter: RntrcFaturamentoFilterPayload): Promise<void> => {
    const { placa, ...resto } = filter;
    void placa;
    return get("/rntrc/faturamento/resumo", clearObject({ ...resto }));
  };

  /** Cliente: os próprios itens; root: prestação de contas (todos os clientes ou o filtrado). */
  const downloadXlsx = (
    filter: RntrcFaturamentoFilterPayload
  ): Promise<void> => {
    const { placa, ...resto } = filter;
    void placa;
    return downloadFile("/rntrc/faturamento/xlsx", clearObject({ ...resto }));
  };

  return {
    data,
    loading,
    listarItens,
    resumo,
    downloadXlsx
  };
};

export { useRntrcFaturamentoService };
